import React from 'react';
import { Handshake } from 'lucide-react';
import Reveal from './Reveal';

import redhatLogo from '../assets/partners/redhat.png';
import onecloudLogo from '../assets/partners/onecloud.png';
import sonarLogo from '../assets/partners/sonar.png';
import fortinetLogo from '../assets/partners/fortinet.png';
import googleCloudLogo from '../assets/partners/google-cloud.png';
import awsLogo from '../assets/partners/aws.png';
import microsoftLogo from '../assets/partners/microsoft.png';
import veeamLogo from '../assets/partners/veeam.png';
import lenovoLogo from '../assets/partners/lenovo.svg';
import huaweiLogo from '../assets/partners/huawei.png';
import invgateLogo from '../assets/partners/invgate.svg';

type Partner = {
  name: string;
  logo: string;
  alt: string;
  large?: boolean;
  small?: boolean;
};

const partners: Partner[] = [
  { name: 'Red Hat', logo: redhatLogo, alt: 'Red Hat', large: true },
  { name: 'ONECLOUD', logo: onecloudLogo, alt: 'ONECLOUD', large: true },
  { name: 'Sonar', logo: sonarLogo, alt: 'Sonar', large: true },
  { name: 'Fortinet', logo: fortinetLogo, alt: 'Fortinet' },
  { name: 'Google Cloud', logo: googleCloudLogo, alt: 'Google Cloud' },
  { name: 'AWS', logo: awsLogo, alt: 'Amazon Web Services', small: true },
  { name: 'Microsoft', logo: microsoftLogo, alt: 'Microsoft' },
  { name: 'Veeam', logo: veeamLogo, alt: 'Veeam' },
  { name: 'Lenovo', logo: lenovoLogo, alt: 'Lenovo' },
  { name: 'Huawei', logo: huaweiLogo, alt: 'Huawei' },
  { name: 'Invgate', logo: invgateLogo, alt: 'Invgate' },
];

const Alianzas: React.FC = () => {
  return (
    <section id="alianzas" className="section-padding bg-surface relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-20 right-20 w-40 h-40 bg-accent-500/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 left-20 w-32 h-32 bg-accent-600/5 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10">
        <Reveal className="text-center mb-16">
          <div className="section-badge">
            <Handshake className="w-4 h-4 mr-2" />
            Alianzas
          </div>

          <h2 className="section-title">
            Nuestras
            <span className="text-accent-400 block">Alianzas</span>
          </h2>

          <p className="section-subtitle max-w-4xl">
            Trabajamos con los líderes tecnológicos del mercado para ofrecerte
            las mejores soluciones Cloud y DevSecOps.
          </p>
        </Reveal>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 items-center max-w-6xl mx-auto">
          {partners.map((partner, index) => (
            <Reveal key={partner.name} delay={(index % 4) * 0.06}>
              <div className="group flex items-center justify-center">
                <div className="bg-white rounded-2xl p-8 md:p-10 w-full h-44 md:h-52 flex items-center justify-center border border-border hover:border-accent-500/50 transition-all duration-300 card-hover">
                  <img
                    src={partner.logo}
                    alt={partner.alt}
                    loading="lazy"
                    decoding="async"
                    className={`max-w-full object-contain transition-opacity duration-300 opacity-90 group-hover:opacity-100 ${
                      partner.large
                        ? 'max-h-32 md:max-h-40 scale-110'
                        : partner.small
                          ? 'max-h-14 md:max-h-16'
                          : 'max-h-24 md:max-h-32'
                    }`}
                  />
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Alianzas;
